module.exports = __webpack_public_path__ + "static/media/1024x768_checkout_building.4215f415.svg";